import { render, staticRenderFns } from "./GuestMeals.vue?vue&type=template&id=0067c68c&scoped=true&"
import script from "./GuestMeals.vue?vue&type=script&lang=ts&"
export * from "./GuestMeals.vue?vue&type=script&lang=ts&"
import style0 from "./GuestMeals.vue?vue&type=style&index=0&id=0067c68c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0067c68c",
  null
  
)

export default component.exports